<template>
  <!-- 外面的盒子 -->
  <div class="wrap-result">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp">
      <div class="header-box">
        <div
          class="userInfo"
          v-for="(item,index) in userList"
          :key="index"
          @click="handleDetail(item)"
        >
          <div class="item firstItem">
            <i>{{item.userName}}</i>
          </div>
          <div class="item">
            <span>手机号码: </span>
            <span>{{item.phoneNum}}</span>
            <div class="list"></div>
          </div>
          <div class="item">
            <span>证件号码: </span>
            <span>{{item.idCardNo}}</span>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <div class="foot">
      <div class="btn" @click="handleAdd">添加成员</div>
    </div>
  </div>
</template>

<script>
import { getApi } from "../../api/index.js";
import MescrollVue from 'mescroll.js/mescroll.vue'
// import mescroll from "mescroll.js/mescroll.vue";
export default {
  components: {
    MescrollVue // 注册mescroll组件
  },
  data() {
    return {
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
      },
      userList: []
    };
  },
  methods: {
    // 下拉刷新选项
    upCallback(page, mescroll) {
      getApi({ url: "/patient/list/" + page.num, query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              let arr = res.data;
              // 如果是第一页需手动置空列表
              if (page.num === 1) this.userList = [];
              // 把请求到的数据添加到列表
              this.userList = this.userList.concat(arr);
              // 数据渲染成功后,隐藏下拉刷新的状态
              this.$nextTick(() => {
                mescroll.endSuccess(arr.length);
              });
            }
          }
        })
        .catch(res => {
          mescroll.endErr();
        });
    },
    handleDetail(item) {
      this.$router.push({
        path: "/patientInfo/info",
        query: {
          personId: item.cardUid
        }
      });
    },
    handleAdd() {
      this.$router.push({
        path: "/patientInfo/info"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.mescroll {
  position: fixed;
  top: 0;
  bottom: 1.22rem;
  height: auto;
}
.wrap-result {
  background-size: 100%;
  width: 100%;
  height: 100%;
  .header-box {
    height: 100%;
    padding-bottom: 0.98rem;
    // overflow: hidden;
    // text-align: center;
    background: #eff3f4;
    overflow: hidden;
  }
}
.userInfo {
  width: 100%;
  height: 2rem;
  box-sizing: border-box;
  padding: 0.34rem 0.33rem 0 0.32rem;
  background: #fff;
  margin-bottom: 0.16rem;
  .item {
    width: 100;
    height: 0.25rem;
    line-height: 0.25rem;
    margin-top: 0.27rem;
    i {
      font-weight: 400;
      font-size: 0.34rem;
      margin-right: 0.14rem;
    }
    span {
      font-size: 0.26rem;
      color: rgb(102, 102, 102);
    }
    .list {
      width: 0.22rem;
      height: 0.4rem;
      float: right;
      background-image: url(../../assets/image/resultList/res.png);
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }

  .firstItem {
    height: 0.32rem;
    margin-top: 0;
    // line-height: .32rem;
    span {
      margin-right: 0.16rem;
    }
  }
}

.userInfo:last-child {
  margin-bottom: 0rem;
}

.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.22rem;
  text-align: center;
  background: #fff;
  padding-top: 0.16rem;
  box-sizing: border-box;
  .btn {
    display: inline-block;
    width: 4rem;
    height: 0.88rem;
    background: #4dcd70;
    line-height: 0.88rem;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 0.3rem;
  }
}
</style>
